export interface UniqueEmailValidationErrorProps {
  value: string;
}
export class UniqueEmailValidationError
  implements UniqueEmailValidationErrorProps
{
  constructor(public value: string) {}
}
